// Shared helpers for the beta optimizer's time restrictions.
//
// A time restriction's channelId is an ARRAY of channel ids (a restriction may
// bound the combined spend of several channels). Plans persisted before the
// multi-channel feature carry a scalar string instead (including the legacy
// '__all__' value), so every reader goes through these helpers.

// Returns the channel ids a time restriction targets, tolerating both the
// current array shape and the legacy scalar shape.
export function timeRestrictionChannelIds (restriction) {
  if (!restriction) return []
  var channelId = restriction.channelId
  if (Array.isArray(channelId)) return channelId
  if (channelId === null || channelId === undefined || channelId === '') return []
  return [channelId]
}

// Returns copies of the given restrictions with channelId coerced to an array.
// Used when hydrating persisted plans so edited/saved plans always write
// arrays. Legacy '__all__' stays as ['__all__'] — it is not expanded to the
// concrete channel list (the backend understands it and the channel set may
// have changed since the plan was created).
export function normalizeTimeRestrictions (restrictions) {
  return (restrictions || []).map(function (r) {
    var copy = Object.assign({}, r)
    copy.channelId = timeRestrictionChannelIds(r)
    return copy
  })
}
